import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../../../shared/models/card.model';

@Component({
  selector: 'app-card-answer',
  templateUrl: './card-answer.component.html',
  styleUrls: ['./card-answer.component.scss']
})
export class AnswerComponent implements OnInit {

  @Input() card: Card;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/remote/card/answer/card-answer.component.ts